module.exports = __webpack_public_path__ + "img/yxt.db2fff8b.png";